import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTestId, useFarbwelt } from "@/hooks";
import { useRefsContext } from "@/contexts/ref";
import { Divider } from "@gemini/ui";
import { Section } from "@/components/UI";
import { useConfig } from "@/contexts/cdpConfig";
import { AdBannerMobile } from "@/components/Ads";
import { FarbweltTeaser } from "@/components/utilsComponents";
import { useIsNewBuildProject } from "@/shared/hooks";
export const Sponsor = () => {
    const testId = useTestId("Sections.Sponsor");
    const { isFarbweltActive, teasers } = useFarbwelt();
    const { sponsorRef } = useRefsContext();
    const isPreviewMode = useConfig().previewMode;
    const isProject = useIsNewBuildProject();
    const teaser = Array.isArray(teasers) && // temporary fix while we wait for bff to return an array
        (teasers === null || teasers === void 0 ? void 0 : teasers.find((teaser) => teaser.type === "MobileBanner"));
    return (_jsx(_Fragment, { children: isPreviewMode || (isFarbweltActive && !teaser) || isProject ? null : (_jsxs(Section, { ref: sponsorRef, testId: testId, hasDivider: false, BoxProps: {
                display: {
                    "breakpoint.lg": "none",
                },
            }, unsafeClassname: "HideOnPrint", children: [isFarbweltActive ? (_jsx(FarbweltTeaser, { teaser: teaser, variant: "mobile", av_zone: "middle" })) : (_jsx(AdBannerMobile, {})), _jsx(Divider, { "aria-hidden": "true", marginBottom: "spacing.40", marginTop: "spacing.40" })] })) }));
};
